import React from 'react';
import styled from 'styled-components';

import { colors, transition } from '../../../utils/styles';
import { LinkButton } from '../../commons';

const { GATSBY_MANAGER_URL } = process.env;

const TopBanner = styled.div`
  width: 100%;
  background-image: ${ ({ isEngagementPage }) =>
    isEngagementPage
      ? 'linear-gradient(to top, #ffffff, #ffa100)'
      : 'linear-gradient(#00a7ff, white)' };
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const TopBannerWrapper = styled.div`
  width: 100%;
  padding-top: 100px;
  text-align: center;
  @media (max-width: 900px) {
    padding-top: 104px;
  }
`;

const BannerHeadingWrappper = styled.div``;

const BannerHeading = styled.h1`
  color: white;
  font-weight: bold;
  font-size: 25px;
  line-height: 1.2;
  margin: auto;

  @media (min-width: 901px) {
    font-size: 45px;
    line-height: 1.24;
    max-width: 680px;
  }

  @media only screen and (min-device-width: 480px) and (max-device-width: 901px) {
    max-width: 400px;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    max-width: 300px;
  }
`;

const SubHeading = styled.h2`
  color: white;
  font-size: 15px;
  line-height: 1.4;
  padding-top: 20px;
  width: 290px;
  margin: 0 auto;
  text-transform: none;
  font-weight: normal;

  @media (min-width: 901px) {
    font-size: 25px;
    line-height: normal;
    padding-top: 20px;
    width: 100%;
  }
`;

const TryItTodayBtn = styled.div`
  margin: 30px auto;
  width: 174px;
  height: 42px;
  border-radius: 25px;
  background-color: white;
  color: #01a7ff;
  line-height: 2.8;
  font-size: 15px;
  font-weight: 700;

  &:after {
    content: 'Try it today';
  }

  &:hover {
    background-color: ${ colors.mainBlue };
    color: white;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
  }

  ${ transition('all 0.3s ease') };
`;

const TopBannerImage = styled.img`
  width: 100%;
  transform: none;
  margin: 0;
  padding: 0 30px;
  margin: 60px auto;
  max-width: 1280px;
  object-fit: contain;
  @media (max-width: 900px) {
    transform: scale(1.7);
    margin: 90px 0;
    padding: 0;
  }
  @media (max-width: 600px) {
    transform: scale(1.7);
    margin: 60px 0;
    padding: 0;
  }
  @media (max-width: 400px) {
    transform: scale(1.7);
    margin: 40px 0 60px;
    padding: 0;
  }
`;

const HeaderIcon = styled.img`
  height: 60px;
  width: 60px;
`;

export default props => (
  <TopBanner isEngagementPage={ props.engagementPage }>
    <TopBannerWrapper>
      <BannerHeadingWrappper>
        { props.headerIconSrcSet && (
          <HeaderIcon srcSet={ props.headerIconSrcSet } />
        ) }
        { props.heading && <BannerHeading>{ props.heading }</BannerHeading> }
      </BannerHeadingWrappper>
      <SubHeading> { props.subHeading } </SubHeading>
      <LinkButton
        href={ `${ GATSBY_MANAGER_URL }/signup` }
        target='_blank'
        rel='noopener noreferrer'
        text='Try it today'
        css='margin-top: 30px;'
        id={ `${ props.source }_top_banner_cta` }
      />
    </TopBannerWrapper>
    <TopBannerImage srcSet={ props.bannerImageSrcSet } />
  </TopBanner>
);



// WEBPACK FOOTER //
// ./src/components/products/membership/topBanner.js